// global.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class GlobalService {

  url = '/api';
  //url = 'https://numero-vip.fr:8443';
  //urlAws = 'https://application.speedysms.fr';
  urlAws = '/api';

  constructor(private httpClient: HttpClient) {}

  headers() {
    const headerSettings: {[name: string]: string | string[]; } = {};
    headerSettings['Content-Type'] = 'application/json';
    
    // ✅ Récupération dynamique du token depuis localStorage
    const token = localStorage.getItem('token');
    if (token) {
      headerSettings['Authorization'] = 'Bearer ' + token;
    }
    
    // ✅ Récupération dynamique de l'ID depuis localStorage
    const userId = localStorage.getItem('id');
    if (userId) {
      headerSettings['id'] = userId;
    }
    
    headerSettings['timeout'] = `${300000}`;
    return new HttpHeaders(headerSettings);
  }

  put(requete: string, body: any): Observable<any> {
    const subject = new Subject<string>();
    this.httpClient
      .put<any>(this.urlAws + requete, body, {headers: this.headers()})
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }

  putWithoutLogged(requete: string, body: any): Observable<any> {
    const subject = new Subject<string>();
    this.httpClient
      .put<any>(this.urlAws + requete, body)
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }

  putWithFile(requete: string, body: any): Observable<any> {
    const subject = new Subject<string>();
    this.httpClient
      .put<any>(this.urlAws + requete, body)
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }

  post(requete: string, body: any): Observable<any> {
    const subject = new Subject<string>();
    console.log(body);
    this.httpClient
      .post<any>(this.urlAws + requete, body, {headers: this.headers()})
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }

  postLogin(requete: string, body: any): Observable<any> {
    const subject = new Subject<string>();
    this.httpClient
      .post<any>(this.url + requete, body)
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }

  patch(requete: string, body: any): Observable<any> {
    const subject = new Subject<string>();
    this.httpClient
      .patch<any>(this.urlAws + requete, body, {headers: this.headers()})
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }

  patchWithoutLogged(requete: string, body: any): Observable<any> {
    const subject = new Subject<string>();
    this.httpClient
      .patch<any>(this.urlAws + requete, body)
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }

  get(requete: string): Observable<any> {
    const subject = new Subject<string>();
    this.httpClient
      .get<any>(this.urlAws + requete, {headers: this.headers()})
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }

  getNotLogged(requete: string): Observable<any> {
    const subject = new Subject<string>();
    this.httpClient
      .get<any>(this.urlAws + requete)
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }

  postBlob(requete: string, body: any): Observable<Blob> {
    const subject = new Subject<Blob>();

    this.httpClient
      .post(this.urlAws + requete, body, {
        headers: this.headers(),
        responseType: 'blob'
      })
      .subscribe(
        (response: Blob) => {
          subject.next(response); // pas besoin de vérifier .status sur un blob
        },
        (err) => {
          subject.error(err); // on passe l'erreur complète
        }
      );

    return subject.asObservable();
  }


  delete(requete: string, id: any): Observable<any> {
    const subject = new Subject<string>();
    this.httpClient
      .delete<any>(this.urlAws + requete + id, {headers: this.headers()})
      .subscribe((response) => {
        if (response.status) {
          subject.next(response);
        }
      }, (err) => {
        subject.next(err.error);
      });
    return subject.asObservable();
  }
}
